var _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFormatGold = function SvgFormatGold(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.625 5.71484C11.0727 5.71484 10.625 6.16256 10.625 6.71484V10.4291C10.625 10.9814 11.0727 11.4291 11.625 11.4291H16C16.5523 11.4291 17 10.9814 17 10.4291V6.71484C17 6.16256 16.5523 5.71484 16 5.71484H11.625Z",
    fill: "#F4A024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0C0.447715 0 0 0.447716 0 1V4.71429C0 5.26657 0.447715 5.71429 1 5.71429H5.375C5.92728 5.71429 6.375 5.26657 6.375 4.71428V1C6.375 0.447715 5.92728 0 5.375 0H1Z",
    fill: "#F4A024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.2852C0.447715 10.2852 0 10.7329 0 11.2852V14.9994C0 15.5517 0.447715 15.9994 1 15.9994H5.375C5.92728 15.9994 6.375 15.5517 6.375 14.9994V11.2852C6.375 10.7329 5.92728 10.2852 5.375 10.2852H1Z",
    fill: "#F4A024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96875 3.40664H6.375V2.30664H6.96875C7.82479 2.30664 8.51875 3.0006 8.51875 3.85664V12.1424C8.51875 12.9984 7.82479 13.6924 6.96875 13.6924H6.375V12.5924H6.96875C7.21728 12.5924 7.41875 12.3909 7.41875 12.1424V3.85664C7.41875 3.60811 7.21728 3.40664 6.96875 3.40664Z",
    fill: "#F4A024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1562 9.12148H7.96875V8.02148H11.1562V9.12148Z",
    fill: "#F4A024"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 2,
    height: 2,
    fill: "#F7B53C"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFormatGold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/format-gold.f510c86c.svg";
export { ForwardRef as ReactComponent };